import {
	type Environment,
	EnvironmentNotProvidedError,
	EnvironmentParameterNotProvidedError,
	type EnvironmentRepository,
	type HttpService,
	isNil,
	type RepositoryType
} from '@contexts/shared/domain';

export function environmentRepositoryBuilder(httpService: HttpService): EnvironmentRepository {
	const environmentFilePath = 'assets/config/environment.json';
	let innerEnvironment: Environment;

	const validate = (environment: Environment): void => {
		if (isNil(environment)) {
			throw new EnvironmentNotProvidedError();
		}

		if (isNil(environment.apiBaseUrl)) {
			throw new EnvironmentParameterNotProvidedError('apiBaseUrl');
		}

		if (isNil(environment.geofenceMinRadius)) {
			throw new EnvironmentParameterNotProvidedError('geofenceMinRadius');
		}
	};

	return {
		async init(): Promise<Environment> {
			try {
				innerEnvironment = (await httpService.get<Environment>(environmentFilePath)).data;
			} catch (e) {
				console.error(e);
			}

			validate(innerEnvironment);

			return innerEnvironment;
		},
		get environment(): Environment {
			return innerEnvironment;
		},
		get apiBaseUrl(): string {
			return innerEnvironment.apiBaseUrl;
		},
		get isProductionEnvironment(): boolean {
			return innerEnvironment.isProductionEnvironment;
		},
		get webSocketBaseUrl(): string {
			return innerEnvironment.webSocketBaseUrl;
		},
		get webSocketReconnectMaxAttempts(): number {
			return innerEnvironment.webSocketReconnectMaxAttempts;
		},
		get webSocketEnabled(): boolean {
			return innerEnvironment.webSocketEnabled;
		},
		get theme(): string {
			return innerEnvironment.theme;
		},
		get delegationGroupContactsLimit(): {
			secondary: number;
			white: number;
			emergency: number;
		} {
			return innerEnvironment.delegationGroupContactsLimit;
		},
		get geofenceMinRadius(): number {
			return innerEnvironment.geofenceMinRadius;
		},
		get repositories(): { [repositoryKey: string]: RepositoryType } {
			return innerEnvironment.repositories;
		}
	};
}
